




















































































































































































































import {Component, Vue, Watch} from 'vue-property-decorator';
import {mapActions, mapMutations, mapState} from 'vuex';

const initialData = {
    loginForm: {
        userName: null,
        password: null,
        rememberMe: false,
    },
    demoForm: {
        name: null,
        organization: null,
        email: null,
        phone: null,
        commentary: null,
        callback: false,
    },
};

@Component({
    computed: {
        ...mapState('login', ['loading', 'wrongLoginOrPassword']),
    },
    methods: {
        ...mapActions(['changeLanguage']),
        ...mapActions('login', ['login', 'logout', 'requestDemo']),
        ...mapMutations('login', ['setWrongLoginOrPassword']),
    },
})
export default class Login extends Vue {
    private tab = 0;
    private loginForm = Object.assign({}, initialData.loginForm);
    private demoForm = Object.assign({}, initialData.demoForm);

    public loading!: boolean;
    public wrongLoginOrPassword!: boolean;
    public login!: Function;
    public logout!: Function;
    public changeLanguage!: Function;
    public setWrongLoginOrPassword!: Function;
    public requestDemo!: Function;

    get items() {
        return [
            this.$t('Main.Authorization'),
            this.$t('Systems.Account.DemoVersion'),
            this.$t('Systems.Account.Contacts'),
        ];
    }

    @Watch('loginForm', {deep: true})
    onLoginFormChange() {
        if (this.wrongLoginOrPassword) this.setWrongLoginOrPassword(false);
    }

    async onLogin() {
        if (!this.loginForm.userName || !this.loginForm.password) return;
        const valid = (this.$refs.login as any).validate();
        if (valid) {
            try {
                await this.login(this.loginForm);
            } catch (e) {
                console.log(e);
            }
        }
    }

    async onRequestDemo() {
        if (!this.demoForm.name || !this.demoForm.email) return;
        const valid = (this.$refs.demo as any).validate();
        if (valid) {
            try {
                await this.requestDemo(this.demoForm);
                this.demoForm = Object.assign({}, initialData.demoForm);
                this.tab = 0;
                this.$toasted.success('Demo request was sent successful', {
                    icon: 'mdi-message-alert',
                    duration: 4000,
                });
            } catch (e) {
                console.log(e);
            }
        }
    }
}
